import styled from "styled-components";
import { Column } from "../../../../components/flex/styled";

export const GetStartedModalWrapper = styled(Column)(() => {
  return {
    gap: 0,
    overflow: "hidden",
    "& .receipt-title>svg": {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
    },
    "& .receipt-title>h2": {
      marginBlockStart: 0,
      textAlign: "center",
    },
    "& p": {
      textAlign: "center",
    },
    "& .otp-container": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "calc(var(--flexGap)/2)",
      marginBlock: "var(--sectionMargin)",
      overflow: "auto",
      width: "80%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    "& .otp-container > input": {
      width: "25%",
      height: "50px",
      fontSize: "1.25rem",
      textAlign: "center",
      padding: "calc(var(--cardPadding)/3) calc(var(--cardPadding)/2)",
      fontWeight: "400",
    },
    "& .submit-button-box": {
      "& button": {
        width: "auto",
        padding: "calc(var(--cardPadding)/3) calc(var(--cardPadding)/2)",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
      },
    },
  };
});
